import "./Print.css";
import * as CSV from "xlsx";

class XlsExport {
  private readonly _audience;
  private readonly _channels;
  private readonly _user;
  private readonly _others;
  private readonly _imgs;

  constructor(audience, channels, user, others, imgs) {
    this._audience = audience;
    this._channels = channels;
    this._user = user;
    this._others = others;
    this._imgs = imgs;
  }

  public exportCSV(filename: string) {
    let tpBase = parseInt(this._others[1]);
    let maxlength = this._audience[0].length - 2 - tpBase;
    let report = new Array();
    let reportRow = new Array(maxlength).fill(""); 
    let col = 0;

    let rowsFirst = this.processLineRowExportCSV(
      reportRow,
      maxlength,
      this._user
    );

    rowsFirst.forEach((item) => {
      report.push(item);
    });

  // reinicializa o reportRow para prevenir mutações em arrays já adicionados ao report
  reportRow = new Array(maxlength).fill("");

  col = 0;
    reportRow[col] = "MIN";
    col++;
    if (tpBase === 0) {
      reportRow[col] = "BASE";
      col++;
    }

    let resultLabel = this.processLineRowExportCSVLabel(col, reportRow);

    col = resultLabel.col;
    reportRow = resultLabel.reportRow;

    report.push(reportRow);
    reportRow = new Array(maxlength).fill("");

    //linha da audiencia
    this._audience.forEach((linha) => {
      col = 0;
      reportRow[col] = linha[1];
      col++;

      let resultLineTypeZero = this.processLine1RowTypeZero(
        tpBase,
        reportRow,
        linha,
        col
      );
      reportRow = resultLineTypeZero.reportRow;
      col = resultLineTypeZero.col;

      let resultLine1 = this.processLine1RowExportCSV(linha, reportRow, col);
      reportRow = resultLine1.reportRow;
      col = resultLine1.col;

      report.push(reportRow);

      reportRow = new Array(maxlength).fill("");
      col = 0;

      if (tpBase === 1 || this._others[2] === 2) {

        let resultLineTypeOne = this.processLine1RowTypeOne(tpBase, reportRow, linha, col); 
        reportRow = resultLineTypeOne.reportRow;
        col = resultLineTypeOne.col; 

        let resultLine2 = this.processLine2RowExportCSV(linha, reportRow, col);
        reportRow = resultLine2.reportRow;
        col = resultLine2.col;

        report.push(reportRow);
        reportRow = new Array(maxlength).fill("");
      }
    });

    const csv_workbook = CSV.utils.book_new();
    const csv_worksheet = CSV.utils.aoa_to_sheet([]);
    CSV.utils.sheet_add_aoa(csv_worksheet, report, { origin: "A1" });

    CSV.utils.book_append_sheet(csv_workbook, csv_worksheet, "Planilha");
    const csvData = CSV.utils.sheet_to_csv(csv_worksheet, {
      FS: ";",
      strip: true,
    });

    // Cria um blob a partir dos dados CSV
    const blob = new Blob(["\uFEFF" + csvData], {
      type: "text/csv;charset=utf-8;",
    });

    // Faz o download do arquivo CSV
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = filename + ".csv";
    downloadLink.click();
  }

  public processLineRowExportCSV(reportRow, maxlength, userData) {
    let newlinha = true;
    let reportResult = new Array();

    userData.forEach((e) => {
      if (newlinha) {
        reportRow[0] = e;
        newlinha = false;
      } else {
        reportRow[1] = e;
        reportResult.push(reportRow);
        reportRow = new Array(maxlength).fill("");
        newlinha = true;
      }
    });
    return reportResult;
  }
  public processLineRowExportCSVLabel(col: number, reportRow) {
    this._channels.forEach((e) => {
      reportRow[col] = e.label;
      col++;
    });
    return { col, reportRow };
  }

  public processLine1RowExportCSV(linha, reportRow, col) {
    // elementos linha 1
    for (let i = 4; i < linha.length; i++) {
      reportRow[col] = linha[i].split("|")[0];
      col++;
    }
    return { col, reportRow };
  }

  public processLine2RowExportCSV(linha, reportRow, col) {
      for (let i = 4; i < linha.length; i++) {
      if (this._others[2] === 2) {
        reportRow[col] = linha[i].split("|")[1];
        col++;
      }
    }
    return { col, reportRow };
  }
  public processLine1RowTypeZero(tpBase, reportRow, linha, col) {
    if (tpBase === 0) {
      reportRow[col] = linha[2];
      col++;
    }
    return { col, reportRow };
  }

  public processLine1RowTypeOne(tpBase, reportRow, linha, col) {
    if (tpBase === 1) {
      reportRow[col] = linha[2];
      col++;
    } else {
      col += 2;
    }
    return { col, reportRow };
  }
}
export default XlsExport;
